<template>
  <div class="tv-player">
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsTizen"
    ></object>
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsLG"
    ></object>
    <video
      v-if="getLGVersion < '5.0'"
      class="tv-player__video"
    ></video>
    <object
      id="av-player"
      class="tv-player__video"
      type="application/avplayer"
      v-if="getIsOrsay"
    ></object>
    <video
      v-if="!getIsOrsay && !getIsLG && !getIsTizen"
      class="tv-player__video"
      src="https://media.digmedia.net/website/video/rain_264.mp4?_=1"
      muted
      autoplay
      loop
    ></video>
    <transition name="fade">
      <div class="tv-osd" v-if="showOSD">
        <!-- <div class="tv-osd" v-if="true"> -->
        <!-- <div id="subtitle" class="subtitle"></div> -->
        <div class="tv-osd__header">
          <div class="tv-osd__header-back">
            <div class="tv-osd__header-app">
              <Icon2
                class="tv-osd__app-icon"
                color="#c1c1c1"
                icon-name="WayfinderRadio"
                :height="96"
                :width="96"
                ><WayfinderRadio />
              </Icon2>
            </div>
            <Icon
              class="tv-osd__back-icon"
              icon-name="WayfinderArrowLeft"
              color="#f1f1f1"
              :height="46"
              :width="46"
              :class="{ 'tv-osd__back-icon--active': isBackButtonActive }"
              ><WayfinderArrowLeft />
            </Icon>
            {{ getBack }}
          </div>
          <div class="tv-osd__header-title">
            {{ $store.getters['radio/getChannelHeadline'] }}
          </div>
        </div>
        <div class="tv-osd__body">
          <ul class="tv-osd__channel-list" ref="listWrapper">
            <li
              v-for="(channel, index) in getChannels"
              :key="'chanel-' + index"
              class="channel-list__channel truncate"
              :class="{
                'channel-list__channel--active':
                  $store.getters['radio/getTargetChannelIndex'] === index &&
                  !isBackButtonActive,
              }"
              :style="getStyleSheetOffset"
              ref="listElements"
            >
              <!--<div class="channel-list__channel-logo-wrapper">
                <template
                  v-if="$store.getters['radio/getEpgById'](channel.epgChannelId)"
                >
                  <img
                    class="channel-list__channel-logo"
                    :src="
                      $store.getters['radio/getEpgById'](channel.epgChannelId)
                        .logo_url
                    "
                    alt=""
                  />
                </template>
              </div>-->
              {{ index + 1 }}. {{ channel.name }}
            </li>
          </ul>
          <div class="tv-osd__channel-info"></div>
        </div>
      </div>
    </transition>
    <!-- Laufender Sender, auch wenn das OSD ausgeblendet ist. Beim Radio gibt
         es kein Bild - ohne diese Zeile stuende nach dem Ausblenden nur noch
         ein leerer Bildschirm da. -->
    <div class="radio-now-playing" v-if="!showOSD && getActiveChannelName">
      <Icon2
        class="radio-now-playing__icon"
        color="#c1c1c1"
        icon-name="WayfinderRadio"
        :height="56"
        :width="56"
        ><WayfinderRadio />
      </Icon2>
      {{ $store.getters['radio/getChannelHeadline'] }}
    </div>
  </div>
</template>

<script>
import DeviceType from '@/helpers/DeviceType';
import { keyHandler, KEYS } from '@/mixins/keyHandler';
import router from '@/router';
import RADIO, { TV_STATUS } from '@/helpers/RADIO';
import Icon from '@/components/Icon.vue';
import Icon2 from '@/components/Icon2.vue';
import WayfinderArrowLeft from '@/assets/icons/WayfinderArrowLeft.vue';
import WayfinderRadio from '@/assets/icons/WayfinderRadio.vue';
import { NAV_TYPE } from '@/store/modules/navigation';

var pressedKey = 0;
var timer = 0;
var maxChannelIndex = 0;
// Senderliste nach dieser Zeit ohne Tastendruck ausblenden; der laufende
// Sender bleibt unten eingeblendet (radio-now-playing).
const OSD_FADE_MS = 10000;

export default {
  components: { Icon, Icon2, WayfinderArrowLeft, WayfinderRadio },
  mixins: [keyHandler],
  data() {
    return {
      error: {
        active: false,
        message: '',
      },
      connectedVideoSources: [],
      availableWindows: [],
      isWindowVisible: false,
      currentWindowSource: null,
      tvPlayer: null,
      tvPlayerState: null,
      ipAddress: null,
      tvStatus: '',
      showOSD: true,
      fadeOutTimer: 0,
      osdInterval: null,
      isBackButtonActive: false,
      activeElement: 0,
      scrollPositionCounter: 0,
      visibleElements: 9,
      wrapperHeight: 0,
      elementHeight: 100,
      scrollCounterOffset: 3,
    };
  },
  watch: {
    fadeOutTimer(value) {
      if (value >= OSD_FADE_MS) {
        this.showOSD = false;
        clearInterval(this.osdInterval);
      }
    },
    showOSD(isTrue) {
      if (isTrue) {
        this.handleOSDFadeInOut();
      }
    },
  },
  methods: {
    handleKeyDown(e) {
      console.log('KEYDOWN EVENT: ', e);
    },
    async init() {
      try {
        this.$store.dispatch('radio/init');
        this.handleOSDFadeInOut();
      } catch (err) {
        console.log(err);
        this.error.active = true;
        this.error.message = 'could not fetch channels';
      }
    },
    resetIntervallTimer() {
      this.fadeOutTimer = 0;
    },
    increaseFadeOutTimer() {
      this.fadeOutTimer += 1000;
    },
    handleOSDFadeInOut() {
      // init und der showOSD-Watcher starten beide - nie zwei Intervalle
      // gleichzeitig laufen lassen.
      clearInterval(this.osdInterval);
      this.osdInterval = setInterval(this.increaseFadeOutTimer, 1000);
    },
    eventHandler(key, event) {
      this.showOSD = true;
      this.resetIntervallTimer();
      switch (key) {
        case KEYS.ENTER:
          if (this.isBackButtonActive) {
            this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
            break;
          }
          // this.toggleWindow();
          this.$store.dispatch(
            'radio/setTargetChannel',
            this.$store.getters['radio/getTargetChannelIndex']
          );
          break;
        case KEYS.CHANNEL_DOWN:
          this.$store.dispatch('radio/setChannelPrev');
          break;
        case KEYS.CHANNEL_UP:
          this.$store.dispatch('radio/setChannelNext');
          break;
        case KEYS.INFO:
          //this.$store.dispatch('radio/showOSD');
          break;
        case KEYS.KEY_0:
        case KEYS.KEY_1:
        case KEYS.KEY_2:
        case KEYS.KEY_3:
        case KEYS.KEY_4:
        case KEYS.KEY_5:
        case KEYS.KEY_6:
        case KEYS.KEY_7:
        case KEYS.KEY_8:
        case KEYS.KEY_9:
          //if(location.hash === '#/' || location.hash === '#/tv-player' || location.hash === '#/tv-player?origin=epg') {
            maxChannelIndex = this.$store.getters['radio/getChannelLength'] - 1;
            if(parseInt(pressedKey) > 0) {
              pressedKey = pressedKey + key;
              if(timer) {
                clearTimeout(timer);
                timer = 0;
              }
            }else if(parseInt(pressedKey) > 9) {
              pressedKey = pressedKey + key;
              if(timer) {
                clearTimeout(timer);
                timer = 0;
              }
            } else {
              pressedKey = key;
            }
            timer = setTimeout(() => {
              let startChannel = {
                "index": parseInt(pressedKey) - 1,
              }
              pressedKey = 0;
              if(startChannel.index <= maxChannelIndex && startChannel.index >= 0) {
                this.$store.commit('radio/setChannelIndex', startChannel.index , { root: true });
                this.$store.commit('radio/setTargetIndex', startChannel.index , { root: true });
                this.$store.commit('radio/setChannel', startChannel.index , { root: true });
              }
            }, 1250);
          //}

          //if (this.getTVStatus === TV_STATUS.LOADED) {
            //console.log("==================KEY", this.getTVStatus);
            //this.$store.dispatch('tv/showOSD');
            //this.$store.dispatch('tv/setShowOSD');
            //this.handleOSDFadeInOut();
            //this.showOSD = true;
          //}
          break;
        case KEYS.BACK:
          if (this.getTVStatus === TV_STATUS.LOADED || this.getTVStatus === TV_STATUS.CLOSED) {
            this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
          }
          break;
        case KEYS.UP:
          if (
            this.$store.getters['radio/getIsFirstChannel'] &&
            !this.isBackButtonActive
          ) {
            this.isBackButtonActive = true;
          } else if (
            this.$store.getters['radio/getIsFirstChannel'] &&
            this.isBackButtonActive
          ) {
            this.isBackButtonActive = false;
            this.$store.dispatch('radio/setTargetPrev');
          } else if (this.isBackButtonActive) {
            this.isBackButtonActive = false;
          } else {
            this.$store.dispatch('radio/setTargetPrev');
          }

          break;
        case KEYS.DOWN:
          if (
            this.$store.getters['radio/getIsLastChannel'] &&
            !this.isBackButtonActive
          ) {
            this.isBackButtonActive = true;
            break;
          }
          if (
            this.$store.getters['radio/getIsLastChannel'] &&
            this.isBackButtonActive
          ) {
            this.isBackButtonActive = false;
            this.$store.dispatch('radio/setTargetNext');
            break;
          }
          if (this.isBackButtonActive) {
            this.isBackButtonActive = false;
            break;
          }
          this.$store.dispatch('radio/setTargetNext');

          break;
      }
    },
    stopTVChannel() {
      try {
        this.$store.dispatch('radio/kill');
      } catch (e) {
        console.log('error on close');
        // this.$store.dispatch('notification/new', {
        //   title: 'Error while stop tv',
        //   message: JSON.stringify(e),
        // });
      }
    },
    callbackTizen(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK TIZEN',
        message: JSON.stringify(context),
      });
      //console.log("CALLBACK TIZEN");
    },
    callbackLG(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK LG',
        message: JSON.stringify(context),
      });
      //console.log("CALLBACK LG");
    },
    callbackOrsay(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK ORSAY',
        message: JSON.stringify(context),
      });
      //console.log("CALLBACK ORSAY");
    },
    callbackFindWindows(context) {
      this.$store.dispatch('notification/new', {
        title: 'CALLBACK TIZEN',
        message: JSON.stringify(context),
      });
      this.availableWindows = context;
    },
    callbackTizenVideoSources(videoSource) {
      this.connectedVideoSources = videoSource.connected;
    },
    callbackLGVideoSources(videoSource) {
      this.connectedVideoSources = videoSource.connected;
    },
    callbackOrsayVideoSources(videoSource) {
      this.connectedVideoSources = videoSource.connected;
    },
  },
  beforeDestroy() {
    clearInterval(this.osdInterval);
    this.$store.dispatch('radio/kill');
  },

  mounted() {
    // if (this.$refs.listElements)
    //   this.elementHeight = this.$refs.listElements[0].offsetHeight;

    if (this.$refs.listWrapper)
      this.wrapperHeight = this.$refs.listWrapper.offsetHeight;

    if (this.$refs.listElements && this.$refs.listWrapper) {
      const calcedItems = Math.floor(this.wrapperHeight / this.elementHeight);
      this.visibleElements = calcedItems < 10 ? calcedItems : 9;
    } else {
      this.visibleElements = 9;
    }
    if (this.visibleElements - this.scrollCounterOffset <= 0) {
      this.scrollCounterOffset = 1;
    } else if (
      this.visibleElements - this.scrollCounterOffset <
      this.scrollCounterOffset
    ) {
      this.scrollCounterOffset =
        this.scrollCounterOffset -
        (this.visibleElements - this.scrollCounterOffset);
    }

    this.init();
  },
  computed: {
    getActiveChannelName() {
      return this.$store.getters['radio/getActiveChannelName'];
    },
    getBack() {
      return this.$i18n('back.name');
    },
    getActiveSubMenuElementIndex: {
      get() {
        return this.$store.getters['navigation/getActiveSubMenuElementIndex'];
      },
    },
    getActiveSubMenu: {
      get() {
        return this.$store.getters['navigation/getActiveSubMenu'];
      },
    },
    getBackground() {
      return this.$store.getters['navigation/getActiveSubMenuBackground'];
    },
    getActiveSubMenuItems: {
      get() {
        return this.getActiveSubMenu.items;
      },
    },
    getActiveItem() {
      return this.$store.getters['navigation/getActiveSubMenuItem'];
    },
    getActiveItemType: {
      get() {
        return this.getActiveItem.type;
      },
    },
    getActiveItemActionUrl: {
      get() {
        return this.getActiveItem.actionUrl;
      },
    },
    getPreviewSource: {
      get() {
        return this.getActiveItem.thumbnail;
      },
    },
    getDescription: {
      get() {
        return this.getActiveItem.description;
      },
    },
    getScrollPosition: {
      get() {
        return this.getScrollPositionCounter * this.elementHeight;
      },
    },
    getStyleSheetOffset: {
      get() {
        return { transform: `translateY(-${this.getScrollPosition}px)` };
      },
    },
    getSubMenuStyle: {
      get() {
        const styles = {
          color: this.textColor,
        };
        console.log(this.getBackground);
        if (this.getBackground)
          styles.backgroundImage = `url(${this.getBackground})`;
        if (this.backgroundColor) styles.backgroundColor = this.backgroundColor;
        else styles.backgroundColor = 'black';
        return styles;
      },
    },
    getScrollPositionCounter() {
      const initialOffset = this.visibleElements - this.scrollCounterOffset;
      if (
        this.getTargetChannelIndex <
        this.visibleElements - this.scrollCounterOffset
      ) {
        return 0;
      }
      if (
        this.getTargetChannelIndex >
        this.getChannelListLength - 1 - this.scrollCounterOffset
      ) {
        return this.getChannelListLength - 1 - this.visibleElements;

        // return (
        //   this.getChannelListLength - initialOffset - this.scrollCounterOffset
        // );
      }
      return this.getTargetChannelIndex - initialOffset;
    },
    getTargetChannelIndex() {
      return this.$store.getters['radio/getTargetChannelIndex'];
    },
    getChannelListLength() {
      return this.$store.getters['radio/getChannelLength'];
    },
    getChannels() {
      return this.$store.getters['radio/getChannels'];
    },
    getIsTizen() {
      return DeviceType.isTizen;
    },
    getLGVersion() {
      return window.lgVersion;
    },
    getIsLG() {
      return DeviceType.isLG;
    },
    getIsOrsay() {
      return DeviceType.isOrsay;
    },
    getCurrentSourceIndex: {
      get() {
        console.log();
        return this.connectedVideoSources.findIndex(
          (el) =>
            el.type === this.currentWindowSource.type &&
            el.number === this.currentWindowSource.number
        );
      },
    },
    getTVStatus() {
      return this.$store.getters['radio/getStatus'];
    },
  },
};
</script>

<style scoped>
.tv-player {
  /* width: 50%; */
  height: 100vh;
  position: relative;
  width: 100vw;
  z-index: 100;
}

h2 {
  font-weight: bold;
  margin: 0.5rem 0;
}
.properties {
  padding-left: 1rem;
}

.tv-player__content {
  display: flex;
}

.tv-player__video {
  background: transparent;
  height: 100vh;
  top: 0;
  position: absolute;
  left: 0;
  width: 100vw;
  z-index: 200;
}
.subtitle {
  background: red;
  color: black;
  min-height: 5vh;
  bottom: 5%;
  position: absolute;
  width: 50vw;
  z-index: 205;
}

.tv-osd {
  color: #f1f1f1;
  left: 0;
  height: 100vh;
  position: absolute;
  top: 0;
  width: 100vw;
  z-index: 210;
}

.tv-osd__header {
  align-items: flex-end;
  border-bottom: 2px solid #f1f1f1;
  display: flex;
  font-size: 6.0vh;
  height: 9.5vh;
  width: 100%;
}

.tv-osd__header-back {
  align-items: center;
  display: flex;
  flex: 0 0 30%;
  padding-left: 1.5rem;
  text-align: left;
}
.tv-osd__header-app {
  display: flex;
  flex-direction: column;
  border-right: 2px solid #f1f1f1;
  padding-right: 0.5rem;
  margin-right: 0.5rem;
}
.tv-osd__header-title {
  padding-left: 1rem;
}

.tv-osd__body {
  align-items: stretch;
  display: flex;
  justify-content: stretch;
  height: calc(100% - 80px);
}
.tv-osd__channel-list {
  flex: 0 0 30%;
  text-align: left;
  overflow: hidden;
  max-height: calc(100vh - 80px);
  width: 30%;
}

.channel-list__channel {
  border: 2px solid transparent;
  border-right: none;
  display: flex;
  padding: 1rem;
  margin: 0.25rem 0 0.25rem 0.25rem;
  font-size: 3.5vh;
  height: 8.5vh;
  transition: transform 0.3s ease-in-out;
}
.channel-list__channel--active {
  border-color: #f1f1f1;
}

.channel-list__channel-logo-wrapper {
  align-items: center;
  background: #f1f1f1;
  border-radius: 5px;
  display: flex;
  height: 7.5vh;
  justify-content: center;
  margin-right: 1vw;
  padding: 5px;
  width: 4vw;
}

.channel-list__channel-logo {
  object-fit: contain;
  height: 100%;
  width: 100%;
}
/* .channel-list__channel-icon {
}
.channel-list__channel-name {
} */

.tv-osd__header,
.tv-osd__channel-list {
  background: rgba(0, 0, 0, 0.7);
}

.tv-osd__header-back,
.tv-osd__channel-list {
  border-right: 2px solid #f1f1f1;
}

.fade-enter-active {
  transition: all 0.1s ease-in-out;
}
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.fade-leave,
.fade-enter-to {
  opacity: 1;
}

.tv-osd__back-icon {
  border: 2px solid transparent;
  padding: 0.5rem;
  margin-right: 1rem;
}
.tv-osd__back-icon--active {
  border-color: #f1f1f1;
}

.radio-now-playing {
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  bottom: 5vh;
  color: #f1f1f1;
  display: flex;
  font-size: 4.5vh;
  left: 1.5rem;
  max-width: 60vw;
  overflow: hidden;
  padding: 1vh 2rem 1vh 1rem;
  position: absolute;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 210;
}
.radio-now-playing__icon {
  margin-right: 1rem;
}

.tv-osd__app-icon {
  /*padding: 0.5rem;
  padding-top: 1rem;*/
}

</style>



// WEBPACK FOOTER //
// src/pages/RadioPlayer.vue